import React, { FunctionComponent, SVGProps, useEffect, useState } from 'react';

import Persona from '@r6digital/rapidstor-types/types/Persona';

import classes from './StorageType.module.scss';

import BusinessImage from '../../assets/business.jpg';
import { ReactComponent as IconBusiness } from '../../assets/icon-business.svg';
import { ReactComponent as IconPersonal } from '../../assets/icon-personal.svg';
import { ReactComponent as ChevronRight } from '../../assets/icon-right-chevron.svg';
import { ReactComponent as IconVehicle } from '../../assets/icon-vehicle.svg';
import PersonalImage from '../../assets/personal.jpg';
import VehicleImage from '../../assets/vehicle.png';

export interface StorageTypeData {
    image: string;
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    name: string;
    type: string;
    filter: string;
    description: string;
}

interface Props {
    setQuestionnaireType: (type: string) => void;
    personas: Persona[] | undefined;
}

function StorageType({ setQuestionnaireType, personas }: Props) {
    const types: StorageTypeData[] = [
        {
            image: PersonalImage,
            icon: IconPersonal,
            name: 'Personal Storage',
            type: 'personal',
            filter: '!Parking',
            description: 'Self storage for individuals, couples or families',
        },
        {
            image: BusinessImage,
            icon: IconBusiness,
            name: 'Business Storage',
            type: 'business',
            filter: '!Parking',
            description: 'Office, Trades, Distributors',
        },
        {
            image: VehicleImage,
            icon: IconVehicle,
            name: 'Car/Boat/Caravan',
            type: 'vehicle',
            filter: 'Parking',
            description: 'Self storage for vehicles and trailers',
        },
    ];

    const [availablePersonas, setAvailablePersonas] = useState<string[]>([]);

    useEffect(() => {
        const typeNames = types.map((type) => type.type);
        const aP = personas?.filter((persona) => {
            return typeNames.includes(persona.parameters[0].value);
        });
        setAvailablePersonas(aP?.map((persona) => persona.parameters[0].value) || []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personas]);

    return (
        <div className={`${classes.container}`}>
            {types.map((type) => {
                if (availablePersonas.includes(type.type)) {
                    return (
                        <div
                            className={`${classes.storage_type}`}
                            key={type.type}
                            onClick={() => setQuestionnaireType(type.type)}
                            data-storage-type={type.type}
                        >
                            <img src={type.image} />
                            <div className={`${classes.outer}`}>
                                <type.icon />
                                <div className={`${classes.inner}`}>
                                    <span>{type.name}</span>
                                    <span>{type.description}</span>
                                </div>
                                <ChevronRight className={`${classes.chevron}`} />
                            </div>
                        </div>
                    );
                }
            })}
        </div>
    );
}

export default StorageType;
